import { render, staticRenderFns } from "./CriterionEvaluationAssessmentForm.vue?vue&type=template&id=7ec68902&scoped=true&"
import script from "./CriterionEvaluationAssessmentForm.vue?vue&type=script&lang=js&"
export * from "./CriterionEvaluationAssessmentForm.vue?vue&type=script&lang=js&"
import style0 from "./CriterionEvaluationAssessmentForm.vue?vue&type=style&index=0&id=7ec68902&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec68902",
  null
  
)

export default component.exports